export default function nullToString(value) {
  return value || "";
}
